import { useEffect, useState } from 'react';
import EditForm from '../../utils/utilities/EditForm';

import { fields, initialValues, schema } from './config';

const EditPromotion = () => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);


  return (
    <EditForm title={"SMS Promotion"} initialValues={initialValues} fields={formFields} schema={schema} url={"messages/promotions"} saveText='Send Promotion' redirect={'/promotions'}>
      
     </EditForm>
  );
}

export default EditPromotion;